import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { User } from '../../../core/models/user';
import Swal from 'sweetalert2';
import { Campaign } from '../../../core/models/campaign';
import { CampaignInfo } from '../../../core/models/campaign_info';
import { ContractsService } from '../../../services/contracts/contracts.service';
import { ContractsCampaigns } from '../../../core/models/client';
import { CampaignCriteria } from '../../../core/models/Campaign_Criterias';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import * as dayjs from 'dayjs';
import { CampaignService } from '../../../services/campaigns/campaign.service';
import { getFirebaseBackend } from 'src/app/authUtils';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from 'src/app/pages/dashboards/dashboard/toast-service';
import { UserService } from 'src/app/services/user/user.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { TIME_ZONES, INDUSTRIES, APPT_TYPES, CRITERIA_TYPES, STATES } from 'src/app/shared/constants';

@Component({
	selector: 'campaign-add',
	templateUrl: './campaign-add.component.html',
	styleUrls: ['./campaign-add.component.scss'],
})
export class CampaignAddComponent implements OnInit {
	public user: User;
	public today: Date = new Date();

	// Constants
	public timezones: any[] = TIME_ZONES;
	public industries: any[] = INDUSTRIES;
	public types: any[] = APPT_TYPES;
	public criteriaTypes: any[] = CRITERIA_TYPES;
	public states: any[] = STATES;

	public campaign: Campaign;

	public formBasicInfo: FormGroup;
	public formCriteria: FormGroup;
	public formCampaignInfo: FormGroup;

	public criterias: CampaignCriteria;
	public criteriasLimits: any;

	public campaignInfo: CampaignInfo;
	public campaignsClient: ContractsCampaigns;

	public campaignLoading: boolean = false;
	public activeTab: string;
	public callSheetTab: string;
	public usersSelect: any[];
	public allcontracts: any[];
	public appt_types: any[];

	constructor(
		private router: Router,
		private campaignService: CampaignService,
		private userSrv: UserService,
		public utils: UtilsService,
		private contractsService: ContractsService,
		private modalService: NgbModal,
	) {
		this.user = getFirebaseBackend()?.getAuthenticatedUser();

		// Initializing Variables
		this.formBasicInfo = new FormGroup({
			name: new FormControl('', Validators.required),
			alias: new FormControl('', Validators.required),
			contract: new FormControl('', Validators.required),
			campaign_type: new FormControl('D', Validators.required),
			prospects_type: new FormControl('B2B'),
			callback_no: new FormControl('', [
				Validators.required,
				Validators.maxLength(10),
			]),
			timezone: new FormControl('', Validators.required),
			points: new FormControl(''),
			industry: new FormControl('', Validators.required),
			source: new FormControl('', Validators.required),
			lead_cost: new FormControl('', Validators.required),
			appts_month: new FormControl('', Validators.required),
			week_1: new FormControl('0'),
			week_2: new FormControl('0'),
			week_3: new FormControl('0'),
			week_4: new FormControl('0'),
			billing_notes: new FormControl(''),
			campaign_notes: new FormControl(''),
		});

		this.formCriteria = new FormGroup({
			asset_size_max: new FormControl(''),
			asset_size_min: new FormControl(''),
			employee_size_max: new FormControl(''),
			employee_size_min: new FormControl(''),
			plan_participants_max: new FormControl(''),
			plan_participants_min: new FormControl(''),
			state: new FormControl(''),
			zip_code: new FormControl(''),
			radius: new FormControl(''),
		});

		this.formCampaignInfo = new FormGroup({
			campaign: new FormControl(''),
			address_1: new FormControl(''),
			address_2: new FormControl(''),
			city: new FormControl(''),
			state: new FormControl(''),
			zip: new FormControl(''),
			website_url: new FormControl(''),
			notes: new FormControl(''),
			questions: new FormControl(''),
			who_we_are: new FormControl(''),
			what_we_do: new FormControl(''),
			why_us: new FormControl(''),
			script: new FormControl(''),
			attending: new FormControl(''),
			scheduling: new FormControl(''),
			additional_calendar_url: new FormControl(''),
			email_template: new FormControl(''),
		});

		this.criteriasLimits = {
			employee_size: false,
			plan_participants: false,
			asset_size: false,
		};

		this.campaignInfo = {
			address_1: 'address_1',
			address_2: '',
			city: 'city',
			state: 'ST',
			zip: '89349',
			website_url: 'website_url',
			notes: 'notes',
			questions: 'questions',
			who_we_are: 'who_we_are',
			what_we_do: 'what_we_do',
			why_us: 'why_us',
			script: 'script',
			attending: 'attending',
			scheduling: 'scheduling',
			additional_calendar_url: 'additional_calendar_url',
			email_template: '',
		};

		this.activeTab = 'basic';
		this.callSheetTab = 'bio';

		this.usersSelect = [];
		this.allcontracts = [];

		this.campaignsClient = {
			idContractsCampaigs: 0,
			contractid: 0,
			alias: '',
			campaignid: 0,
			userid: 0,
			contractid_ini: 0,
		};

		this.criterias = {
			section_employee_size: false,
			section_asset_size: false,
			section_plan_participants: false,
			section_state: false,
			section_zip_code: false,
			asset_size_max: 0,
			asset_size_min: 0,
			employee_size_max: 0,
			employee_size_min: 0,
			state: '',
			zip_code: '',
			radius: 0,
			plan_participants_min: 0,
			plan_participants_max: 0,
			prospects_from: 'LMS',
		};

		this.appt_types = [];
	}

	ngOnInit() {
		// if (this.user.isAdmin != 1) {
		//     // this.authenticationService.logout('');
		//     location.reload();
		// }

		this.userSrv.getClientUsersSelect().subscribe((data: any) => {
			this.usersSelect = data.body;
		});
		this.getAllContracts();
	}

	criteriaSelected(criteria) {
		switch (criteria) {
			case 'employee_size':
				this.criterias.section_employee_size = !this.criterias.section_employee_size;
				if (this.criterias.section_employee_size) {
					this.formCriteria
						.get('employee_size_max')
						.setValue(900000000);
					this.formCriteria
						.get('employee_size_min')
						.addValidators(Validators.required);
				} else {
					this.formCriteria
						.get('employee_size_min')
						.removeValidators(Validators.required);
				}
				break;

			case 'asset_size':
				this.criterias.section_asset_size = !this.criterias.section_asset_size;
				if (this.criterias.section_asset_size) {
					this.formCriteria.get('asset_size_max').setValue(900000000);
					this.formCriteria
						.get('asset_size_min')
						.addValidators(Validators.required);
				} else {
					this.formCriteria
						.get('asset_size_min')
						.removeValidators(Validators.required);
				}
				break;

			case 'plan_participants':
				this.criterias.section_plan_participants =
					!this.criterias.section_plan_participants;
				if (this.criterias.section_plan_participants) {
					this.formCriteria
						.get('plan_participants_max')
						.setValue(900000000);
					this.formCriteria
						.get('plan_participants_min')
						.addValidators(Validators.required);
				} else {
					this.formCriteria
						.get('plan_participants_min')
						.removeValidators(Validators.required);
				}
				break;

			case 'state':
				this.criterias.section_state = !this.criterias.section_state;
				if (this.criterias.section_state) {
					this.formCriteria
						.get('state')
						.addValidators(Validators.required);
				} else {
					this.formCriteria
						.get('state')
						.removeValidators(Validators.required);
				}
				break;

			case 'zip_code':
				this.criterias.section_zip_code =
					!this.criterias.section_zip_code;
				if (this.criterias.section_zip_code) {
					this.formCriteria
						.get('zip_code')
						.addValidators([
							Validators.required,
							Validators.maxLength(5),
						]);
					this.formCriteria
						.get('radius')
						.addValidators(Validators.required);
				} else {
					this.formCriteria
						.get('zip_code')
						.removeValidators([
							Validators.required,
							Validators.maxLength(5),
						]);
					this.formCriteria
						.get('radius')
						.removeValidators(Validators.required);
				}
				break;
		}
	}

	limitSelected(criteria: string) {
		switch (criteria) {
			case 'employee_size':
				this.criteriasLimits.employee_size =
					!this.criteriasLimits.employee_size;
				if (this.criteriasLimits.employee_size) {
					this.formCriteria.get('employee_size_max').setValue(0);
				} else {
					this.formCriteria
						.get('employee_size_max')
						.setValue(900000000);
				}
				break;

			case 'asset_size':
				this.criteriasLimits.asset_size =
					!this.criteriasLimits.asset_size;
				if (this.criteriasLimits.asset_size) {
					this.formCriteria.get('asset_size_max').setValue(0);
				} else {
					this.formCriteria.get('asset_size_max').setValue(900000000);
				}
				break;

			case 'plan_participants':
				this.criteriasLimits.plan_participants =
					!this.criteriasLimits.plan_participants;
				if (this.criteriasLimits.plan_participants) {
					this.formCriteria.get('plan_participants_max').setValue(0);
				} else {
					this.formCriteria
						.get('plan_participants_max')
						.setValue(900000000);
				}
				break;
		}
	}

	typesContain(type: number) {
		if (this.appt_types) {
			return this.appt_types.indexOf(type) > -1 ? true : false;
		} else {
			return false;
		}
	}

	isValidURL(str) {
		const regex =
			/(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
		if (!regex.test(str)) {
			return false;
		} else {
			return true;
		}
	}

	validateCriterias() {
		if (
			!(
				this.criterias.section_asset_size ||
				this.criterias.section_employee_size ||
				this.criterias.section_plan_participants ||
				this.criterias.section_state ||
				this.criterias.section_zip_code
			)
		) {
			Swal.fire({
				title: 'Check criterias',
				text: 'Is recomended add a criteria to the campaign',
				showCancelButton: true,
				confirmButtonText: 'Go to Criterias',
				cancelButtonText: 'No Criterias',
			}).then((result) => {
				if (!result.value) {
					this.validateBasicInfo();
				} else {
					this.activeTab = 'criteria';
				}
			});
		} else {
			this.validateBasicInfo();
		}
	}

	validateBasicInfo() {
		if (this.formBasicInfo.valid) {
			this.saveCampaign();
		} else {
			this.formBasicInfo.markAllAsTouched();
			this.utils.swal(
				'Check your data',
				'error',
				'Please fill all required items',
			);
		}
	}

	saveCampaign() {
		const campaignBasic = this.formBasicInfo.getRawValue();
		const campaignCriterias = this.formCriteria.getRawValue();
		const campaign_info = this.formCampaignInfo.getRawValue();

		this.campaign = {
			name: campaignBasic.name,
			alias: campaignBasic.alias,
			contract_rules: 0,
			timezone: campaignBasic.timezone,
			callback_no: campaignBasic.callback_no,
			leads_needed: 0,
			points: campaignBasic.points,
			lead_cost: campaignBasic.lead_cost,
			industry: campaignBasic.industry,
			types: this.appt_types,
			isActive: 0,
			created: dayjs().format('YYYY-MM-DD HH:mm:ss'),
			created_by: this.user.id,
			modified: dayjs().format('YYYY-MM-DD HH:mm:ss'),
			modified_by: this.user.id,
			campaign_type: campaignBasic.campaign_type,
			source: campaignBasic.source,
			appts_month: campaignBasic.appts_month,
			week_1: campaignBasic.week_1,
			week_2: campaignBasic.week_2,
			week_3: campaignBasic.week_3,
			week_4: campaignBasic.week_4,
			billing_notes: campaignBasic.billing_notes,
			campaign_notes: campaignBasic.campaign_notes,
			contractid: campaignBasic.contract,
			email_template: campaign_info.email_template,
		};

		this.criterias.asset_size_max =
			campaignCriterias.asset_size_max == ''
				? 0
				: campaignCriterias.asset_size_max;
		this.criterias.asset_size_min =
			campaignCriterias.asset_size_min == ''
				? 0
				: campaignCriterias.asset_size_min;
		this.criterias.employee_size_max =
			campaignCriterias.employee_size_max == ''
				? 0
				: campaignCriterias.employee_size_max;
		this.criterias.employee_size_min =
			campaignCriterias.employee_size_min == ''
				? 0
				: campaignCriterias.employee_size_min;
		this.criterias.plan_participants_max =
			campaignCriterias.plan_participants_max == ''
				? 0
				: campaignCriterias.plan_participants_max;
		this.criterias.plan_participants_min =
			campaignCriterias.plan_participants_min == ''
				? 0
				: campaignCriterias.plan_participants_min;
		this.criterias.state = campaignCriterias.state;
		this.criterias.zip_code = campaignCriterias.zip_code;
		this.criterias.radius =
			campaignCriterias.radius == '' ? 0 : campaignCriterias.radius;
		this.criterias.prospects_from = 'LMS';

		this.campaignService
			.saveCampaign(this.campaign, this.criterias, campaign_info)
			.then((data) => {
				if (data.success) {
					Swal.fire(
						'Succcess',
						`Campaign ${this.campaign.name} was created with id ${data.idCampaign} successfuly`,
						'success',
					).then((data) => {
						this.router.navigate(['/admin/campaigns']);
					});
				}
			});
	}

	setTypes(type: number) {
		const index = this.appt_types.indexOf(type);
		if (index > -1) {
			this.appt_types.splice(index, 1);
		} else {
			this.appt_types.push(type);
		}
	}

	getAllContracts() {
		this.contractsService.getAllContracts().subscribe((data: any) => {
			if (!data.hasOwnProperty('error')) {
				if (data.body.length > 0) {
					this.allcontracts = data.body;
				} else {
					this.allcontracts = [];
				}
			} else {
				this.allcontracts = [];
			}
		});
	}
}
